
export const limitText = (text, limit) => {
    return text?.length > limit ? text.slice(0, limit) + "..." : text;
}


export function formatDateFromUnixTimestamp(unixTimestamp) {
    const timestampMilliseconds = unixTimestamp * 1000;
    const date = new Date(timestampMilliseconds);

    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };

    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    return formattedDate;
}

export function formatCurrency(amount) {
    // Convert the number to a string with two decimal places
    if (typeof amount === 'string') {
        amount = parseInt(amount, 10);
    }
    const formattedAmount = amount.toFixed(2);

    // Add commas for thousands separators
    const parts = formattedAmount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Add the dollar sign and combine the parts
    return "$ " + parts.join(".");
}

export function capitalizeAndReplace(inputString) {
    // Split the input string by hyphens
    if (inputString === '2-3-users-license') {
        return "2-3 Users License";
    }
    const words = inputString.split('-');

    // Capitalize each word and join them with spaces
    const capitalizedString = words.map(word => {
        // Capitalize the first letter of each word
        const capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1);
        return capitalizedWord;
    }).join(' ');

    return capitalizedString;
}


export function HTMLParser(data, callback) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');
    var firstH6Replaced = false
    const h6Elements = doc.querySelectorAll('h6');
    const headingH2Elements  = doc.querySelectorAll('h2');
    h6Elements.forEach((h6Element, index) => {
        if (index === 0 && !firstH6Replaced) {
            const h2Element = document.createElement('h2');
            h2Element.className = "text-lg font-semibold mb-2 relative text-[#1b5df3]";
            h2Element.innerHTML = h6Element.innerHTML;
            h6Element.parentNode.replaceChild(h2Element, h6Element);
            firstH6Replaced = true;
        } else {
            const h3Element = document.createElement('h3');
            h3Element.className = 'text-lg font-semibold text-[#1b5df3]';
            h3Element.innerHTML = h6Element.innerHTML;
            h6Element.parentNode.replaceChild(h3Element, h6Element);
        }
    });
    headingH2Elements.forEach((headingH6Element, index) => {
        if (index === 0 && !firstH6Replaced) {
            const headingH2Element = document.createElement('h2');
            headingH2Element.className = "text-lg font-semibold mb-2 relative text-[#1b5df3]";
            headingH2Element.innerHTML = headingH6Element.innerHTML;
            headingH6Element.parentNode.replaceChild(headingH2Element, headingH6Element);
            firstH6Replaced = true;
        } else {
            const h3Element = document.createElement('h3');
            h3Element.className = 'text-lg font-semibold text-[#1b5df3]';
            h3Element.innerHTML = headingH6Element.innerHTML;
            headingH6Element.parentNode.replaceChild(h3Element, headingH6Element);
        }
    });

    // const strongUElements = doc.querySelectorAll('strong');
    // strongUElements.forEach((strongUElement) => {
    //     strongUElement.outerHTML = strongUElement.innerHTML;
    // });

    const ulElements = doc.querySelectorAll('ul');
    ulElements.forEach((ulElement) => {
        ulElement.className = 'px-4 m-4 list-disc';
    });


    // Replace strong tags with their content
    const strongUElements = doc.querySelectorAll('strong');
    strongUElements.forEach((strongUElement) => {
        strongUElement.outerHTML = strongUElement.innerHTML;
    });

    // Remove the specified span tag
    const spanElements = doc.querySelectorAll('span[style="color: rgb(0, 0, 0);"]');
    spanElements.forEach((spanElement) => {
        spanElement.outerHTML = spanElement.innerHTML;
    });

    let paraRemove = doc.body.innerHTML.replace(/<br>/g, '')
    let paraSpace = paraRemove.replace(/&nbsp;/g, '')
    let cond1 = paraSpace.replace(/background-color: transparent;/g, '')
    let cond2 = cond1.replace(/class="ql-align-justify"/g, '')

    let finalOutput = cond2.replace(/<p><\/p>/g, '')
    callback(finalOutput)
}